import React, { useState, useEffect, useRef } from "react";
import {
	MenuItem,
	FormHelperText,
	Select,
	Checkbox,
	ListItemText,
	InputLabel,
	Tooltip,
} from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { isArray } from "lodash";
import { Mandatory } from "../../FormHelpers";
import {
	ChipsContainer, ChipText, FormControlMultiple, FormControlSingle,
	PositionCloseIcon, SelectContainer, StyledMenuItem
} from "./Styled";
import { ImagePath } from "../../../../../assets/ImagePath";
import CachedImage from "../../../../common/CachedImage";


const SelectInput = (props) => {
	const {
		id,
		info,
		readOnly,
		value,
		handleChange,
		onBlurField,
		validation,
		validationResult,
		validationMessage,
		options,
		multiple,
		title,
		type,
		islabelvisible,
		mandatory
	} = props;

	const [selectOption, setSelectOption] = useState([]);
	const [val, setVal] = useState(value);
	const [multiVal, setMultiVal] = useState((Array.isArray(value) && value) || []);
	const [multiSelectWidth, setMultiSelectWidth] = useState(500);
	const multiSelectRef = useRef(null);

	useEffect(() => {
		const multiWidth = multiSelectRef?.current?.offsetWidth;
		multiWidth && setMultiSelectWidth(multiWidth - 60);
	}, []);

	const [shouldShowClrIcon, setShouldShowClrIcon] = useState(false);

	const handleSelect = (e) => {
		setVal(e.target.value);
		setMultiVal(e.target.value);
		handleChange(e, type, e.target.value);
		onBlurField(e);
		console.log(e)
	};
	const onClear = () => {
		if (!readOnly) {
			setVal("");
			const fakeEvt = { target: { name: id, value: "" } };
			handleSelect(fakeEvt);
		}
	};

	const onClearMultiple = () => {
		if (!readOnly) {
			setMultiVal([]);
			const fakeEvt = { target: { name: id, value: [] } };
			handleSelect(fakeEvt);
		}
	};

	const handleMouseEnter = () => {
		if (!readOnly) {
			setShouldShowClrIcon(true);
		}
	};

	const handleMouseLeave = () => {
		if (!readOnly) {
			setShouldShowClrIcon(false);
		}
	};

	useEffect(() => {
		if (multiple) {
			if (Array.isArray(value)) {
				setMultiVal(value);
			} else {
				let valueArray = [];
				value && valueArray.push(value);
				setMultiVal(valueArray);
			}
		} else {
			setVal(value);
		}
		if (!options?.length && value) {
			if (Array.isArray(value)) {
				setSelectOption(value);
			}
			else {
				setSelectOption([value]);
			}
		} else if (options && Array.isArray(options)) {
			if (!options?.includes(value)) {
				if (isArray(value)) {
					setSelectOption([...new Set([...options, ...value])]);
				} else {
					setSelectOption([...options, value]);
				}
			} else {
				setSelectOption(options);
			}
		}
	}, [options, value, readOnly, multiple]);

	const handleItemDelete = (e, value) => {
		e.preventDefault();
		let valAfterDeletion = multiVal.filter((val) => val !== value);
		setMultiVal(valAfterDeletion);
		const fakeEvt = { target: { name: id, value: valAfterDeletion } };
		handleChange(fakeEvt, type);
		onBlurField(fakeEvt);
	};

	const isBoolean = (val) => "boolean" === typeof val;
	if (multiple) {
		return (
			<div className="relative flex items-start gap-1 update-input">

				<div className="w-full">
					<div className="flex items-center gap-1 mb-[5px]">
						<span className="min-w-[17px] h-[17px] rounded-7 flex items-center justify-center">
							<CachedImage
								image={ImagePath.dropdownIcon}
								imgKey="drop-picker-Icon"
								className="w-[17px] h-[17px]"
							/>
						</span>
						{!islabelvisible && <label className="text-size-14 text-[#15194B] font-regular mt-[2px]">
							{mandatory &&
								<Mandatory {...props} />}{title}
						</label>}
					</div>
					<FormControlMultiple
						fullWidth
						isValue={Boolean(value?.length)}
						multiSelWidth={multiSelectWidth}
						size="small"
						variant="outlined"
						disabled={readOnly}
						error={
							validation && isBoolean(validationResult) ? !validationResult : false
						}
					>
						{/*{(isSmallScreen || isSections === true) && (*/}
						{/* {!islabelvisible && (
							<InputLabel id={id}>
								<Mandatory {...props} />
								{title}
							</InputLabel>
						)} */}
						{/*)}*/}
						<Select
							className="under-slect"
							ref={multiSelectRef}
							labelId={id}
							multiple
							id={id}
							name={id}
							value={multiVal || []}
							onChange={handleSelect}
							variant="outlined"
							notched={true}
							onMouseEnter={handleMouseEnter}
							onMouseLeave={handleMouseLeave}
							renderValue={(selected) => (
								<ChipsContainer>
									{selected &&
										selected.length > 0 &&
										selected?.map((value) => (
											<ChipText
												key={value}
												label={value}
												deleteIcon={
													<ClearIcon onMouseDown={(e) => e.stopPropagation()} />
												}
												onDelete={(e) => handleItemDelete(e, value)}
											/>
										))}
								</ChipsContainer>
							)}
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "center",
								},
								style: {
									maxHeight: 80 * 4.5,
								},
								sx: {
									zIndex: "999999999",
									"&& .Mui-selected": {
										backgroundColor: "#eff4ff",
										border: "1px solid rgba(196, 216, 255, 0.5)",
									},
									"&& .MuiMenuItem-root:hover": {
										backgroundColor: "#eff4ff",
									},
									"&& .MuiMenuItem-root:focus": {
										backgroundColor: "#eff4ff",
									},
								},
							}}
						>
							{selectOption.map((item) => {
								if (item) {
									return (
										<StyledMenuItem key={item} value={item} style={{ fontSize: "14px" }} className="multiselect-item">
											<ListItemText primary={item} />
											<Checkbox
												color="primary"
												className="checkbox-widgt"
												checked={multiVal?.indexOf(item) > -1}
												style={{
													color: "#638dff",
													borderRadius: "4px",
												}}
											/>
										</StyledMenuItem>
									);
								}
								return null;
							})}
						</Select>
						{(!props.inline || validationMessage) && (
							<FormHelperText className="!text-size-14" sx={{ color: "#e5453b !important" }}>
								{isBoolean(validationResult) && !validationResult
									? validationMessage
									: info}
							</FormHelperText>
						)}
					</FormControlMultiple>
				</div>
			</div>
		);
	};

	return (
		<div className="relative flex items-start gap-1 update-input">

			<div className="w-full">
				<div className="flex items-center gap-1 mb-[5px]">
					<span className="min-w-[17px] h-[17px] rounded-7 flex items-center justify-center">
						<CachedImage
							image={ImagePath.dropdownIcon}
							imgKey="drop-picker-Icon"
							className="w-[17px] h-[17px]"
						/>
					</span>
					{!islabelvisible && <label className="text-size-14 text-[#15194B] font-regular mt-[2px]">
						{title}{mandatory &&
							<Mandatory {...props} />}
					</label>}
				</div>
				<FormControlSingle
					fullWidth
					variant="outlined"
					disabled={readOnly}
					size="small"
					error={
						validation && isBoolean(validationResult) ? !validationResult : false
					}
					value={id}
					label={id}
					inputvalue={val || ""}
				>
					<Tooltip title={(val?.length > 40) ? val : ""} arrow placement={"top"}>
						<SelectContainer
							labelId={id}
							id={id}
							name={id}
							value={val || ""}
							onMouseEnter={handleMouseEnter}
							onMouseLeave={handleMouseLeave}
							onChange={handleSelect}
							notched={true}
							variant="outlined"
							MenuProps={{
								anchorOrigin: {
									vertical: "bottom",
									horizontal: "center",
								},
								style: {
									maxHeight: 65 * 4.5,
								},
								sx: {
									zIndex: "999999999",
									"&& .Mui-selected": {
										backgroundColor: "#eff4ff",
									},
									"&& .MuiMenuItem-root:hover": {
										backgroundColor: "#eff4ff",
									},
									"&& .MuiMenuItem-root:focus": {
										backgroundColor: "#eff4ff",
									},
								},
							}}>
							{selectOption?.map((item) => {
								if (item) {
									return (
										<MenuItem key={item} value={item} style={{ color: "#44485a", fontSize: "14px" }}>
											{item}
										</MenuItem>
									);
								}
								return null;
							})}
						</SelectContainer>
					</Tooltip>
					{shouldShowClrIcon && (
						<PositionCloseIcon
							fontSize="small"
							onClick={onClear}
							style={{ cursor: 'pointer' }}
							onMouseEnter={handleMouseEnter}
						/>
					)}
					{(!props.inline || validationMessage) && (
						<FormHelperText className="!text-size-14" sx={{ color: "#e5453b !important" }}>
							{isBoolean(validationResult) && !validationResult
								? validationMessage
								: info}
						</FormHelperText>
					)}
				</FormControlSingle>
			</div>
		</div>
	);
};

export default SelectInput;
